export const fr = {
  open: 'Ouvrir',
  close: 'Fermer',
  share: 'Partager sur',
  languages: 'Langues',
  footer: {
    copyright: '© 2018 Codeurs, Tous droits réservés.'
  },
  contact: {
    name: 'Nom',
    email: 'Email',
    question: 'Message',
    submit: 'Envoyer',
    thanks: 'Merçi pour votre message'
  },
  error404: {
    title: 'Page non trouvée',
    text: `La page que vous recherchez a peut-être été supprimée, 
				son nom a été modifié ou est temporairement indisponible.`,
    btn: "Retour à l'accueil"
  },
  cookies: {
    text: 'Ce site internet utulise des cookies pour améliorer votre expérience de surf.',
    accept: 'Accepter les cookies',
    decline: 'Refuser les cookies'
  },
  header: {
    top: {
      text: 'Informations et services officiels',
      link: 'https://www.belgium.be/fr'
    }
  },
  previewlink: {readmore: 'En savoir plus'},
  contentpage: {
    related_publication: 'Publication connexe',
    related_articles: 'Articles connexes'
  },
  library: {
    all_years: 'Toutes les années',
    filter: {
      type: 'Filtrer par type :',
      category: 'Filtrer par niveau :',
      themes: 'Filtrer par thème :'
    },
    published: 'Publié',
    search: 'Chercher dans ',
    select_year: 'Sélectionnez une année',
    loadmore: "Charger plus d'articles",
    title: 'Filtrer par année'
  },
  sidebar: {related: 'TOBETRANSLATED'},
  search: {
    title: 'Résultats',
    noresult: "Aucun résultat n'a été trouvé."
  },
  sharepage: 'Partager',
  sitemap: {
    home: "Page d'accueil",
    home2050: "Page d'accueil 2050",
    homecbam: "Page d'accueil CBAM"
  },
  years: 'Toutes les années',
  newsletter: {
    btn: 'Newsletter',
    label: 'Vers la newsletter',
    submit: 'Inscrivez-vous à la newsletter',
    error:
      "Une erreur s'est produite lors de l'envoi du formulaire. Veuillez réessayer plus tard."
  }
}
